import { Component, OnInit } from '@angular/core';
import { TrackingService } from '../../tracking.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser'; 

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css']
})
export class TrackingComponent implements OnInit {

  summaryArray=[]
  track_number: any;
  trackData: any;
  fpodImg: any;
  podImg: any;
  errMsg: any;
  dlyMsg: any="";
  visibleDownload: any=0;

  constructor(public service: TrackingService, public route: ActivatedRoute,
    private _sanitizer: DomSanitizer,private titleService: Title,  
    private metaTagService: Meta) {
    route.queryParams.subscribe(
      params => {this.track_number = params['no']
      this.submit()
    });
    // this.route.params.subscribe(datas => {
    //   this.track_number = datas['no'];
    //   console.log(datas)
    //   this.submit()
    // });
  }

  ngOnInit(): void {
    this.titleService.setTitle("Example of SEO Meta Tag using Angular");  
    
    this.metaTagService.addTags([  
      { name: 'keywords', content: 'Angular SEO Title, Meta Description, Meta Keyword Example' },  
      { name: 'robots', content: 'index, follow' },  
      { name: 'writer', content: 'John Smith' },  
      { charset: 'UTF-8' }  
    ]);  
  }
  view_pod(data)
  {
    console.log(data)
    this.fpodImg=""
    this.service.view_pod(data.details[0].invoice_no).subscribe(res=>{
      this.podImg=res['data']
      // this.fpodImg = 
      if(this.podImg != 0)
      {
        this.fpodImg = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
        + this.podImg);
        this.visibleDownload = '1'
      }
    })
  }
  convertBase64ToBlobData(base64Data: string, contentType: string='image/png', sliceSize=512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  download_pod(podImg,inv)
  {
    const blobData = this.convertBase64ToBlobData(podImg);
 // chrome
      const blob = new Blob([blobData]);
      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = inv+'.jpg';
      link.click();
  }
  
  submit()
  {
    this.visibleDownload = '0'
    this.fpodImg=""
    this.summaryArray=[]
    this.trackData=[]
    var data = this.track_number.split(' ')
    this.service.getMultiTracking(data).subscribe(res=>{
      if(res['code'] == '200')
      {
        this.trackData = res['data']
        this.errMsg = ""
        this.dlyMsg=this.trackData[0].details[0].current_status
        console.log(this.trackData)
        for (let i = 0; i < this.trackData.length; i++) {
         
          this.service.view_pod(this.trackData[i]['details'][0]['invoice_no']).subscribe(res=>{
            this.podImg=res['data']
            // this.fpodImg = 
            if(this.podImg != 0)
            {
              this.fpodImg = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
              + this.podImg);
              this.trackData[i]['details'][0]['pod']= this.fpodImg 
              this.trackData[i]['details'][0]['podImg']= this.podImg 
          
              this.visibleDownload = '1'
            }
          })
          this.summaryArray.push(this.trackData[i]['summary'])
        
        }
      }
      else
      {
        this.errMsg = "No Data Found!"
      }
      
    })
  }
}
